export enum PRODUCT_DISCOUNT_PERMISSIONS {
  PRODUCT_DISCOUNT_VIEW = 'OFFER_PRODUCTVIEW',
  PRODUCT_DISCOUNT_WRITE = 'OFFER_PRODUCTWRITE',
}
